import { LoadingState } from "@material-dev/insights-portal-ui-components/lib/types";
import { PowerBIFileDto } from "app/ApiClient";

export enum PowerBIProjectStatuses {
  New = "New",
  InProgress = "InProgress",
  Failed = "Failed",
  Completed = "Completed",    
}

export interface PowerBIProjectState {
  result: Nullable<PowerBIFileDto>;
  loading: LoadingState;
  isExportPowerBIProjectDialogOpen: boolean;
  exportProjectErrorMessage?: string;
  PowerBIProjectStatus?: PowerBIProjectStatuses;
}

export const initialPowerBIProjectState: PowerBIProjectState = {
    loading: LoadingState.idle,
    isExportPowerBIProjectDialogOpen: false,
    PowerBIProjectStatus: PowerBIProjectStatuses.New,
    result: null,
};
